import request from '../utils/request'

// 绑定微信
export function bindWechat (data) {
  return request.post('/usr/bind/wechat', data)
}

// 获取账号列表
export function fetchAccounts () {
  return request.get('/usr/bind/accounts')
}

// 确认账号选择
export function confirmSelect (data) {
  return request.post('/usr/bind/confirm', data)
}
